"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetDisplayBrowserMetadataDataDto = exports.DisplayOutputStateMetadataDto = exports.DisplayPlayerVersionMetadataDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class DisplayPlayerVersionMetadataDto {
    packageName;
    versionName;
    versionCode;
}
exports.DisplayPlayerVersionMetadataDto = DisplayPlayerVersionMetadataDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.Matches)(/^[a-zA-Z][a-zA-Z0-9_]*(?:\.[a-zA-Z0-9_]+)+$/),
    __metadata("design:type", String)
], DisplayPlayerVersionMetadataDto.prototype, "packageName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(64),
    __metadata("design:type", String)
], DisplayPlayerVersionMetadataDto.prototype, "versionName", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(1),
    __metadata("design:type", Number)
], DisplayPlayerVersionMetadataDto.prototype, "versionCode", void 0);
class DisplayOutputStateMetadataDto {
    state;
    source;
    confidence;
    observedAt;
    androidInteractive;
    hdmiConnected;
    cecAvailable;
    logicalDisplayState;
    tvPowerStatus;
    detail;
}
exports.DisplayOutputStateMetadataDto = DisplayOutputStateMetadataDto;
__decorate([
    (0, class_validator_1.IsIn)(["active", "android-suspended", "hdmi-disconnected", "tv-standby", "unknown"]),
    __metadata("design:type", String)
], DisplayOutputStateMetadataDto.prototype, "state", void 0);
__decorate([
    (0, class_validator_1.IsIn)(["android-power", "display-manager", "hdmi-hotplug", "hdmi-cec", "combined", "unsupported"]),
    __metadata("design:type", String)
], DisplayOutputStateMetadataDto.prototype, "source", void 0);
__decorate([
    (0, class_validator_1.IsIn)(["high", "medium", "low"]),
    __metadata("design:type", String)
], DisplayOutputStateMetadataDto.prototype, "confidence", void 0);
__decorate([
    (0, class_validator_1.IsISO8601)(),
    __metadata("design:type", String)
], DisplayOutputStateMetadataDto.prototype, "observedAt", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DisplayOutputStateMetadataDto.prototype, "androidInteractive", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DisplayOutputStateMetadataDto.prototype, "hdmiConnected", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DisplayOutputStateMetadataDto.prototype, "cecAvailable", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(32),
    __metadata("design:type", String)
], DisplayOutputStateMetadataDto.prototype, "logicalDisplayState", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(["on", "standby", "transient-to-on", "transient-to-standby", "unknown"]),
    __metadata("design:type", String)
], DisplayOutputStateMetadataDto.prototype, "tvPowerStatus", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(160),
    __metadata("design:type", String)
], DisplayOutputStateMetadataDto.prototype, "detail", void 0);
class SetDisplayBrowserMetadataDataDto {
    instanceId;
    coordinationEpoch;
    screenData;
    windowData;
    browserData;
    memoryData;
    playerType;
    macAddress;
    playerVersion;
    outputState;
}
exports.SetDisplayBrowserMetadataDataDto = SetDisplayBrowserMetadataDataDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(["player-web", "player-native"]),
    __metadata("design:type", String)
], SetDisplayBrowserMetadataDataDto.prototype, "playerType", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Matches)(/^([0-9A-F]{2}:){5}[0-9A-F]{2}$/),
    __metadata("design:type", String)
], SetDisplayBrowserMetadataDataDto.prototype, "macAddress", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => DisplayPlayerVersionMetadataDto),
    __metadata("design:type", DisplayPlayerVersionMetadataDto)
], SetDisplayBrowserMetadataDataDto.prototype, "playerVersion", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => DisplayOutputStateMetadataDto),
    __metadata("design:type", DisplayOutputStateMetadataDto)
], SetDisplayBrowserMetadataDataDto.prototype, "outputState", void 0);
